import React, { useState } from 'react';

/**
 * Free-form keyword chips for subscription voicemail keyword routing.
 * Enter or comma commits a keyword; empty strings are ignored.
 */
const SubscriptionKeywordsInput = ({
  value = [],
  onChange,
  placeholder = 'Type a keyword and press Enter',
  className = '',
  inputClassName = 'w-full p-2 border rounded',
  disabled = false,
}) => {
  const [draft, setDraft] = useState('');
  const keywords = Array.isArray(value) ? value : [];

  const commitDraft = () => {
    const parts = draft
      .split(',')
      .map((k) => k.trim())
      .filter(Boolean);
    if (parts.length === 0) {
      setDraft('');
      return;
    }
    const next = [...keywords];
    parts.forEach((part) => {
      if (!next.some((k) => k.toLowerCase() === part.toLowerCase())) {
        next.push(part);
      }
    });
    onChange(next);
    setDraft('');
  };

  const removeKeyword = (keyword) => {
    onChange(keywords.filter((k) => k !== keyword));
  };

  return (
    <div className={className}>
      {keywords.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-2">
          {keywords.map((keyword) => (
            <span
              key={keyword}
              className="inline-flex items-center gap-1 px-2 py-0.5 text-xs rounded-full bg-amber-100 text-amber-900"
            >
              {keyword}
              {!disabled && (
                <button
                  type="button"
                  onClick={() => removeKeyword(keyword)}
                  className="text-amber-700 hover:text-amber-950"
                  aria-label={`Remove ${keyword}`}
                >
                  ×
                </button>
              )}
            </span>
          ))}
        </div>
      )}
      <input
        type="text"
        value={draft}
        disabled={disabled}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            commitDraft();
          } else if (e.key === 'Backspace' && !draft && keywords.length > 0) {
            removeKeyword(keywords[keywords.length - 1]);
          }
        }}
        onBlur={commitDraft}
        className={inputClassName}
        placeholder={placeholder}
      />
    </div>
  );
};

export default SubscriptionKeywordsInput;
